import { render } from "./Logo.vue?vue&type=template&id=65db38a4"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"
script.render = render

export default script